export default {
  christmas: {
    id: 'christmas',
    name: 'Christmas',
    theme: 'christmas', // References the theme key in themes.js
    startDate: {
      day: 1,
      month: 12, // December
      year: null, // null = repeats every year
    },
    endDate: {
      day: 31,
      month: 12, // December
      year: null, // null = repeats every year
    },
    banner: {
      component: true, // Components in /components/holiday/christmas/Banner.vue
    },
    logo: {
      icon: require('~/assets/images/logo/logo-white-icon-hat.png'),
      full: require('~/assets/images/logo/logo-white-full-hat.png'),
    },
    animation: {
      enabled: true,
      component: true, // Components in /components/holiday/christmas/Animation.vue
      menuButton: {
        component: true, // Components in /components/holiday/christmas/Button.vue
      },
    },
  },
  /* halloween: {
    id: 'halloween',
    name: 'Halloween',
    theme: 'midnight', // Using existing midnight theme as base
    startDate: {
      day: 15,
      month: 10, // October
      year: null, // null = repeats every year
    },
    endDate: {
      day: 31,
      month: 10, // October
      year: null, // null = repeats every year
    },
    banner: {
      component: false, // No banner component yet
    },
    logo: {
      icon: require('~/assets/images/logo/logo-white-icon.png'), // TODO: Create Halloween logo variants
      full: require('~/assets/images/logo/logo-white-full.png'),
    },
    animation: {
      enabled: false,
      component: false,
      menuButton: {
        component: false,
      },
    },
  },
  valentines: {
    id: 'valentines',
    name: "Valentine's Day",
    theme: 'lipStick', // Using existing lipStick theme as base
    startDate: {
      day: 7,
      month: 2, // February
      year: null, // null = repeats every year
    },
    endDate: {
      day: 14,
      month: 2, // February
      year: null, // null = repeats every year
    },
    banner: {
      component: false, // No banner component yet
    },
    logo: {
      icon: require('~/assets/images/logo/logo-white-icon.png'), // TODO: Create Valentine's logo variants
      full: require('~/assets/images/logo/logo-white-full.png'),
    },
    animation: {
      enabled: false, // Can be enabled when animation is created
      component: false,
      menuButton: {
        component: false,
      },
    },
  }, */
}
